<template>
  <div>
    <el-dialog
      top="10vh"
      width="330px"
      center
      title="回收积分"
      :visible="bankRecycleDialogObj.visible"
      @close="HandleClose()"
    >
      <el-form :rules="rules" :model="editData" :ref="form" label-width="70px">
        <el-form-item label="卡主">
          {{ bankRecycleDialogObj.username }}
        </el-form-item>
        <el-form-item label="银行卡">
          {{ bankRecycleDialogObj.bankCardNumber }}
        </el-form-item>
        <el-form-item prop="amount" label="金额">
          <el-input v-model="editData.amount" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleClose()"> 取消 </el-button>
        <el-button
          :loading="submitLoading"
          round
          type="success"
          @click="HandleVaild()"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { accountRecycle } from "@/api/account";

export default {
  mixins: [mainCommon],
  props: ["bankRecycleDialogObj"],
  data() {
    return {
      editData: {},
      submitLoading: false,
      form: "form",
      rules: {
        amount: [
          {
            required: true,
            message: "输入非正数或必填项目为空",
            pattern:
              /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/,
          },
        ],
      },
    };
  },
  methods: {
    HandleClose() {
      this.$refs[this.form].resetFields();
      this.editData = {};
      this.$emit("update:bank-recycle-dialog-obj", {});
    },
    HandleVaild() {
      this.$refs[this.form].validate((valid) => {
        if (valid) this.HandleSubmit();
      });
    },
    HandleSubmit() {
      this.submitLoading = true;
      accountRecycle(this.bankRecycleDialogObj.id, this.editData)
        .then((res) => {
          this.$notify.success(res.message);
          this.HandleClose();
          this.$emit("HandleGetList");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/code/BankRecycleDialog.vue